import { Routes, Route } from "react-router-dom";
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { UserContext } from "./UserContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Import all possible components
import Profile from "./components/Profile";
import CompanyList from "./components/CompanyList";
import ClientEnquiryForm from "./components/ClientEnquiryForm";
import ClientEnquiryDetails from "./components/ClientEnquiryDetails";
import EnquiryDashboard from "./components/EnquiryDashboard";
import UserRegistration from "./components/UserRegistration";
import EmployeeList from "./components/EmployeeList";
import ActivityLog from "./components/ActivityLog";
import FeedbackDetails from "./components/FeedbackDetails";
import AddProduct from "./components/AddProduct";
import Dashboard from "./components/Dashboard";
import AddService from "./components/AddService";
import { Attendance } from "./components/Attendance";
import AdminSetting from "./components/AdminSetting";
import AdminPage from "./components/AdminPage";
import EnquiryImport from "./components/EnquiryImport";
import GenerateTCO from "./components/GenerateTCO";
import InvoiceTabWrapper from "./components/Finance/InvoiceTabWrapper";

function getSidebarElementComponent(elementName) {
  switch (elementName) {
    case "Profile":
      return <Profile />;
    case "CompanyList":
      return <CompanyList />;
    case "UserRegistration":
      return <UserRegistration />;
    case "ClientEnquiryForm":
      return <ClientEnquiryForm />;
    case "EmployeeList":
      return <EmployeeList />;
    case "AddProduct":
      return <AddProduct />;
    case "ActivityLog":
      return <ActivityLog />;
    case "Dashboard":
      return <Dashboard />;
    case "AddService":
      return <AddService />;
    case "Attendance":
      return <Attendance />;
    case "AdminPage":
      return <AdminPage/>;
    case "EnquiryImport":
      return <EnquiryImport/>;
    case "GenerateTCO":
      return <GenerateTCO/>;
    case "InvoiceTabWrapper":
      return <InvoiceTabWrapper/>;
    default:
      return null;
  }
}
function SidebarRouteRendere(props) {
  const { role } = useContext(UserContext);
  console.log("role",role)
  const [sidebarData, setSidebarData] = useState([]);
  console.log("sidebarData",sidebarData)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `/api/sidebar-permission/?role_name=${role}`
        );
        setSidebarData(response.data);
      } catch (error) {
        console.error("Error fetching sidebar data:", error);
      }
    };
    fetchData();
  }, [role]);

  // Filter for items with is_view: true for the current role
  const filteredSidebarItems = sidebarData.filter(item =>
    item.roles.some(
      r => r.role_name === role && r.permissions.is_view
    )
  );
console.log("filteredSidebarItems",filteredSidebarItems)
  return (
    <Routes>
      {/* Dynamically render routes from sidebarData */}
      {filteredSidebarItems.map(item => (
        <Route
          key={item.sidebar_id}
          path={item.action_link}
          element={
            <ProtectedRoute>
              {getSidebarElementComponent(item.component_name)}
            </ProtectedRoute>
          }
        />
      ))}
        <Route path="/client_enquiry_detail/:id" element={<ProtectedRoute> <ClientEnquiryDetails /></ProtectedRoute>} />
        <Route path="/timeline/:enquiryId/:companyId/:exportCompanyId" element={<ProtectedRoute> <EnquiryDashboard /></ProtectedRoute>} />
        <Route path="/feedback_details/:id" element={<ProtectedRoute> <FeedbackDetails /></ProtectedRoute>} />
        <Route path="/ClientEnquiryForm" element={<ProtectedRoute> <ClientEnquiryForm /></ProtectedRoute>} />
        <Route path="/UserRegistration" element={<ProtectedRoute> <UserRegistration /></ProtectedRoute>} />
        <Route path="/employeelist" element={<ProtectedRoute> <EmployeeList /></ProtectedRoute>} /> 
        <Route path="/CompanyList" element={<ProtectedRoute> <CompanyList /></ProtectedRoute>} /> 
        <Route path="/AddService" element={<ProtectedRoute> <AddService /></ProtectedRoute>} /> 
        <Route path="/AddProduct" element={<ProtectedRoute> <AddProduct /></ProtectedRoute>} /> 
        <Route path="/Dashboard" element={<ProtectedRoute> <Dashboard /></ProtectedRoute>} /> 
        <Route path="/profile" element={<ProtectedRoute>  <Profile /></ProtectedRoute>} /> 
        <Route path="/Attendance" element={<ProtectedRoute>  <Attendance/></ProtectedRoute>} /> 
        <Route path="/AdminPage" element={<ProtectedRoute> <AdminPage /></ProtectedRoute>} />
        <Route path="/EnquiryImport" element={<ProtectedRoute> <EnquiryImport /></ProtectedRoute>} />
        <Route path="/adminsetting/:roleId" element={<ProtectedRoute><AdminSetting /></ProtectedRoute>} />
    </Routes>
  );
}

export default SidebarRouteRendere;
